// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./about-total-placeholder.png");
var dir = previousRequest.replace("about-total-placeholder.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "about-total-placeholder.png",
	name: "about-total-placeholder",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/about-total-placeholder.png
// module id = 97
// module chunks = 4